export const FilterViewProps = {
  FILTERVIEW_FILTERS: 'appliedFilters',
  FILTERVIEW_FILTER_SEARCH: 'filterSearch',
  FILTERVIEW_FILTER_COUNT: 'filterCount',
  FILTERVIEW_GLOBAL_SEARCH: 'globalSearch',
  FILTERVIEW_SEARCH_COUNT: 'globalSearchCount',
  FILTERVIEW_COLUMNS: 'columnConfiguration',
  FILTERVIEW_SORTBY: 'sortBy',
};
